import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.css']
})
export class InformationDialogComponent {

  constructor(public dialogRef: MatDialogRef<InformationDialogComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any) {
  }

  /**
   * Closes the dialog and executes the callback function associated with the dialog data
   */
  public closeDialog(): void{
    this.dialogData.callback();
    this.dialogRef.close();
  }

}
